import React, { useEffect, useState,useRef } from "react";
import { Card, CardBody, Row, Col,Container } from "reactstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import { getWorkOrderDetailsAPIURL, getExecutionRescheduleReasonAPIURL, patchRescheduleWOExecutionAPIURL, patchCancelWorkOrderAPIURL } from "BaseComponentAPI/WorkOrderListAPI";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { checkPermissions } from "components/Common/ChkPermissions";
import CantAccessPage from "components/Common/CantAccessPage";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Loader from "components/Common/Loader";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import PopupWindow from "components/Common/PopupWindow";
import "./WorkOrderDetailsV2.css";



<style>
    {`
  .datepicker-popper {
    margin-top: 4px !important;   /* ⭐ reduced gap */
    z-index: 9999;
  }

  /* Fix triangle alignment */
  .react-datepicker__triangle {
    left: 50% !important;
    transform: translateX(-50%);
  }

  .react-datepicker {
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    border: none;
  }
`}
</style>



const WorkOrderDetailsV2 = () => {

const authUser = useSelector((state) => state.Login);
        document.title = "Cockpit";
const { woId, woExId } = useParams();
const navigate = useNavigate();

const location = useLocation();
const { fromDate, toDate } = location.state || {};

const [data, setData] = useState(null);
const storedPermissions = JSON.parse(localStorage.getItem("permissions")) || {};
const { canRead } = checkPermissions(storedPermissions);

const [loaderOption, setLoaderOption] = useState(false);
const [isPopupVisible, setIsPopupVisible] = useState(false);
const [popupMessage, setPopupMessage] = useState("");
const [popupType, setPopupType] = useState("");

//const [workOrderExecutionss, setWorkOrderExecutions] = useState([]);
const [postponeData, setPostponeData] = useState({});
const [reasonOptions, setReasonOptions] = useState([]);
const [reasonLoaded, setReasonLoaded] = useState(false);
const [woLoaded, setWOLoaded] = useState(false);
const [woCancelReasonOptions, setWoCancelReasonOptions] = useState([]);
const [cancelData, setCancelData] = useState({});
const [cancelreasonLoaded, setCancelReasonLoaded] = useState(false);

const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    fetchWorkOrder();
  }, []);



const getExecutionStatus = (exe) => {
  if (exe.isExecutionCancelled === "Yes") return "cancelled";
  if (exe.isExecutionCompleted === "Yes") return "completed";

  // ⏱ SLA Logic (basic)
  if (exe.executionDate && exe.executionTime) {
    const [day, month, year] = exe.executionDate.split("/");
    const scheduled = new Date(`${year}-${month}-${day} ${exe.executionTime}`);
    
    if (new Date() > scheduled) return "delayed";
  }
  return "pending";
};

const getBadgeClass = (status) => {
  switch (status) {
    case "Completed":
      return "bg-success";
    case "Yes":
      return "bg-success";  
    case "Cancelled":
      return "bg-danger";
    case "Delayed":
      return "bg-warning text-dark";
    case "Pending":
      return "bg-warning text-dark";  
    default:
      return "bg-secondary";
  }
};

const getBadgeClassForWOType = (status) => {
  switch (status) {
    case "Complaint":
      return "bg-danger";
    case "One Time":
      return "bg-warning text-dark";
    case "Maintanance Contract":
      return "bg-warning text-dark";
    default:
      return "bg-secondary";
  }
};


const getBadgeClassForExecutionCancelled = (status) => {
  switch (status) {
    case "Yes":
      return "bg-danger";
    case "No":
      return "bg-success";  
    // case "Cancelled":
    //   return "bg-danger";
    // case "Delayed":
    //   return "bg-warning text-dark";
    // case "Pending":
    //   return "bg-warning text-dark";  
    default:
      return "bg-secondary";
  }
};

const getBadgeClassForWOCancelled = (status) => {
  switch (status) {
    case "Yes":
      return "bg-danger";
    case "No":
      return "bg-success";  
    // case "Cancelled":
    //   return "bg-danger";
    // case "Delayed":
    //   return "bg-warning text-dark";
    // case "Pending":
    //   return "bg-warning text-dark";  
    default:
      return "bg-secondary";
  }
};

const getBadgeClassForWOOverallStatus = (status) => {
  switch (status) {
    case "Partially Completed":
      return "bg-warning text-dark";
    case "Pending":
      return "bg-warning text-dark"; 
    case "Completed":
      return "bg-success";  
    case "Cancelled":
       return "bg-danger";
    // case "Delayed":
    //   return "bg-warning text-dark";
    // case "Pending":
    //   return "bg-warning text-dark";  
    default:
      return "bg-secondary";
  }
};

const getWoBorderClass = (wo) => {
  if (wo?.isWoCancelled === "Yes") return "border-danger";
  if (wo?.woExecutionStatus === "Completed") return "border-success";
  return "border-warning";
};

const initializeExecution = (exeUUID) => {
  setPostponeData(prev => ({
    ...prev,
    [exeUUID]: prev[exeUUID] || {
      date: "",
      time: "",
      reasonUUID:"",
      reason: "",
      remark: ""
    }
  }));
};

const initializeWoCancellation = (woUUID) => {
  setCancelData(prev => ({
    ...prev,
    [woUUID]: prev[woUUID] || {    
      reasonUUID:"",
      reason: "",
      remark: ""
    }
  }));
};

const handlePostponeChange = (exeUUID, field, value) => {
  setPostponeData(prev => ({
    ...prev,
    [exeUUID]: {
      ...prev[exeUUID],
      [field]: value
    }
  }));
};

const handleCancellationChange = (woUUID, field, value) => {
  setCancelData(prev => ({
    ...prev,
    [woUUID]: {
      ...prev[woUUID],
      [field]: value
    }
  }));
};

const handleReschedule = (exe) => {
  const data = postponeData[exe.exeUUID];

  if (!data?.date || !data?.time || !data?.reason) {
   
    openPopup("Please fill reschedule details !!!" , "warn");
    return;
  }

  const scheduledDateTime = `${data.date} ${data.time}:00`;
  //const isoDateTime = new Date(`${data.date}T${data.time}`).toISOString();
  // console.log("Payload:", {
  //   exeUUID: exe.exeUUID,
  //   scheduledDateTime:scheduledDateTime,
  //   reasonUUID: data.reasonUUID,
  //   reason: data.reason,
  //   remark: data?.remark || "",
  //   schedulerMessage: data?.schedulerMessage || "",
  // });

  const payload= {
    userUUID:authUser.headers.userUUID,
    exeUUID: exe.exeUUID,
    scheduledDateTime:scheduledDateTime,
    reasonUUID: data.reasonUUID,
    reason: data.reason,
    remark: data?.remark || "",
    schedulerMessage: data?.schedulerMessage || "",
  };
   console.log(payload);
  // openPopup(JSON.stringify(payload), "warn");
  UpdateWOExecutionSchedule(payload);
  // 👉 API call here
};


const handleCancelWorkOrderProcess = (woUUID) => {
  const data = cancelData[woUUID];
//console.log(data);
  if (!data?.reason || !data?.remark) {
   
    openPopup("Please fill wo Cancellation reason & remark !" , "warn");
    return;
  }

  const payload= {
    userUUID:authUser.headers.userUUID,
    woUUID: woUUID,    
    reasonUUID: data.reasonUUID,
    reason: data.reason,
    remark: data?.remark || "",    
  };
   console.log(payload);
  
    CancelWorkOrder(payload);
  // 👉 API call here
};


    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };



  const fetchWorkOrder = async () => {
    setWOLoaded(true);
    try {
      // 🔁 Replace with your API    

             const response = await axios.get(
                    `${getWorkOrderDetailsAPIURL}?userUUID=${authUser.headers.userUUID}&exeUUID=${woExId}&woUUID=${woId}`,
                    {
                        headers: {
                            ...authUser.headers,
                            Authorization: `Bearer ${authUser.headers.access_token}`,
                        },
                    }
                );
       // ✅ prevent multiple calls
      setData(response.data.data);

      if(response.data.data.workOrderExecutions){
      const hasAnyPostpone = response.data.data.workOrderExecutions.some(
      exe =>
        exe.isExecutionCompleted === "Pending" &&
        exe.isExecutionCancelled === "No"
        );
        
        if(hasAnyPostpone){
          //alert('found');
          fetchRescheduleReasons();
        }          
      }

      if(response.data.data.workOrderMaster){
          
          if(response.data.data.workOrderMaster.woExecutionStatus === "Pending" && response.data.data.workOrderMaster.isWoCancelled === "No")
          {
            fetchWoCancelReasons();
          }     
      }


    } catch (err) {
      console.error(err);
    }
  };

const CancelWorkOrder = async (payload) => {
    //setWOLoaded(true);
    try {
      // 🔁 Replace with your API    

             const response = await axios.patch(
                    `${patchCancelWorkOrderAPIURL}`,payload,
                    {
                        headers: {
                            ...authUser.headers,
                            Authorization: `Bearer ${authUser.headers.access_token}`,
                        },
                    }
                );
       // ✅ prevent multiple calls
              if(response.data.responseCode === 0 && response.data.statusCode === 200)
                {
                  openPopup("Work order cancelled successfully, please confirm the change done." , "success");
                }
              else
                {
                  openPopup(response.data.responseMsg , "warn");
                }   
    } catch (err) {
      console.error(err);
       if (err.response) {
          openPopup(err.response.data.responseMsg , "warn");
       }
        
    }
  };


  const UpdateWOExecutionSchedule = async (payload) => {
    setWOLoaded(true);
    try {
      // 🔁 Replace with your API    

             const response = await axios.patch(
                    `${patchRescheduleWOExecutionAPIURL}`,payload,
                    {
                        headers: {
                            ...authUser.headers,
                            Authorization: `Bearer ${authUser.headers.access_token}`,
                        },
                    }
                );
       // ✅ prevent multiple calls
              if(response.data.responseCode === 0 && response.data.statusCode === 200)
                {
                  openPopup("Work order execution rescheduled successfully, please confirm the change done." , "success");
                }
              else
                {
                  openPopup(response.data.responseMsg , "warn");
                }   
    } catch (err) {
      console.error(err);
       if (err.response) {
          openPopup(err.response.data.responseMsg , "warn");
       }
        
    }
  };

const fetchRescheduleReasons = async () => {
    try {
      // 🔁 Replace with your API    

             const response = await axios.get(
                    `${ getExecutionRescheduleReasonAPIURL }11ef347b-4f1b-3602-862c-b8ca3ad15bed?woUUID=${woId}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: {
                            ...authUser.headers,
                            Authorization: `Bearer ${authUser.headers.access_token}`,
                        },
                    }
                );
    //   setData(response.data.data);
    const options = response.data.data.items.map(r => ({
      value: r.reasonUUID,
      label: r.reasonTemplateStr
    }));

    setReasonOptions(options);
    setReasonLoaded(true); // ✅ prevent multiple calls
    } catch (err) {
      //console.error(err);
      console.error("Failed to load reasons", err);
    }
  };


  const fetchWoCancelReasons = async () => {
    try {
      // 🔁 Replace with your API    

             const response = await axios.get(
                    `${ getExecutionRescheduleReasonAPIURL }77b78543-42e4-11f1-a70f-22f17ecb52c5?woUUID=${woId}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: {
                            ...authUser.headers,
                            Authorization: `Bearer ${authUser.headers.access_token}`,
                        },
                    }
                );
    //   setData(response.data.data);
    const options = response.data.data.items.map(r => ({
      value: r.reasonUUID,
      label: r.reasonTemplateStr
    }));

    setWoCancelReasonOptions(options);
    setCancelReasonLoaded(true); // ✅ prevent multiple calls
    } catch (err) {
      //console.error(err);
      console.error("Failed to load wo lost reasons", err);
    }
  };

const handleCopyDetailAddress = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    //alert("Address copied!");
  } catch (err) {
    console.error("Copy failed", err);
  }
};

const handleCopyLocationAddress = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    //alert("Address copied!");
  } catch (err) {
    console.error("Copy failed", err);
  }
};

  if (!data) return <div>Loading...</div>;






const {  workOrderMaster,  workOrderAddress,  workOrderDetails,  workOrderExecutions} = data;


const processedExecutions = workOrderExecutions?.map((exe) => ({
  ...exe,
  status: getExecutionStatus(exe),
})) || [];



    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Work Order List" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
              <div className="workorder-page">
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Users" breadcrumbItem="Work Order Details" />

                                {/* 🔹 1. WORK ORDER INFO */}
                                <Card className="mb-3 shadow-sm">
                                  <CardBody>
                                    <div
                                    className={`border rounded p-3 mb-3 ${getWoBorderClass(workOrderMaster)}`}
                                            >
                                    <Row>
                                    <Col md={9}><h5 className="mb-3">Work Order Information</h5></Col>
                                    <Col md={3}>                                  
                                   
                                          <div className="col-sm-12">
                                              {/* ✅ Back Button */}
                                              <button
                                                  type="button"
                                                  className="btn btn-sm btn-warning"
                                                  style={{ fontWeight: "500", fontSize: '12px', float: 'right' }}
                                                  onClick={() => {
                                                      navigate('/workOrderList', {
                                                          state: {
                                                              fromDate,
                                                              toDate,
                                                              triggerFetch: true   // ⭐ ADD THIS FLAG
                                                          }
                                                      });
                                                  }}
                                              >
                                                  Back To WO List
                                              </button>
                                          </div> 
                                        </Col>
                                    </Row>
                                    {/* <h5 className="mb-3">Work Order Information</h5> */}
                                    <Row>
                                        {/* <Col md={4}><div className="label-text" style={{ fontSize: "14px" }}>WO Serial</div><div>{workOrderMaster.woSerialNo}</div></Col> */}
                                        <Col md={3}><div className="label-text;">WO Serial</div><div className="value-text" style={{ fontSize: "14px", fontWeight:"500" }}> {workOrderMaster.woSerialNo} </div></Col>
                                        <Col md={3}><div className="label-text">WO Type</div><div className="value-text"> {workOrderMaster.woType} </div></Col>
                                        <Col md={3}><div className="label-text">WO Final Amount ₹</div><div className="value-text"> {workOrderMaster.woFinalAmount} </div></Col>
                                        <Col md={3}><div className="label-text">Total Exe. Pending</div><div className="value-text"> {workOrderMaster.noOfExecutionPending} </div></Col>
                                       </Row>
                                       <Row className="mb-3"></Row>                                      
                                       <Row>
                                        <Col md={3}><div className="label-text">First Exe. Date</div><div className="value-text" style={{ fontSize: "14px", fontWeight:"500" }}> {workOrderMaster.firstExecutionDate} </div></Col>
                                        <Col md={3}><div className="label-text">First Exe. Time</div><div className="value-text"> {workOrderMaster.firstExecutionTime} </div></Col>
                                        <Col md={3}><div className="label-text">Overall Status</div><div className={`badge ${getBadgeClassForWOOverallStatus(workOrderMaster.woExecutionStatus)} px-3 py-2 status-badge`}> {workOrderMaster.woExecutionStatus.toUpperCase()} </div></Col>
                                        <Col md={3}><div className="label-text">Total Exe. at System</div><div className="value-text"> {workOrderMaster.noOfExecutionCreatedAtSystem} </div></Col>
                                      </Row>
                                      <Row className="mb-3"></Row>     
                                      <Row>
                                        <Col md={3}><div className="label-text">Total Exe. Completed</div><div className="value-text" style={{ fontSize: "14px", fontWeight:"500" }}> {workOrderMaster.noOfExecutionCompleted} </div></Col>
                                        <Col md={3}><div className="label-text">WO Booked At</div><div className="value-text"> {workOrderMaster.woBookedAt} </div></Col>
                                        <Col md={3}><div className="label-text">WO Booked By</div><div className="value-text"> {workOrderMaster.woBookedBy} </div></Col>
                                        <Col md={3}><div className="label-text">Payment Mode</div><div className="value-text"> {workOrderMaster.woPaymentMode} </div></Col>
                                      </Row>
                                      <Row className="mb-3"></Row>     
                                      <Row>
                                        <Col md={6}><div className="label-text">Message For Operation Executive</div><div className="value-text" style={{ fontSize: "14px", fontWeight:"500" }}> {workOrderMaster.messageForScheduler} </div></Col>                                        
                                        <Col md={3}><div className="label-text">Is WO Cancelled</div><div className={`badge ${getBadgeClassForWOCancelled(workOrderMaster.isWoCancelled)} px-3 py-2 status-badge`}> {workOrderMaster.isWoCancelled.toUpperCase()} </div></Col>
                                        <Col md={3}><div className="label-text">Payment Status</div><div className="value-text"> {workOrderMaster.woPaymentStatus} </div></Col>
                                      </Row>
                                      <Row className="mb-3"></Row>     
                                      <Row>                                        
                                        <Col md={3}><div className="label-text">Cancellation At</div><div className="value-text"> {workOrderMaster.woCancellationDateTime} </div></Col>
                                        <Col md={3}><div className="label-text">Cancellation By</div><div className="value-text"> {workOrderMaster.woCancellationBy} </div></Col>
                                        <Col md={3}><div className="label-text">Cancellation Reason</div><div className="value-text"> {workOrderMaster.woCancellationReason} </div></Col>
                                        <Col md={3}><div className="label-text">Cancellation Remark</div><div className="value-text"> {workOrderMaster.woCancellationRemark} </div></Col>
                                      </Row>
                                        {/* <Col md={4}><div className="text-muted" style={{ fontSize: "14px" }}>WO Type</div><div>{workOrderMaster.woType}</div></Col>
                                        <Col md={4}><div className="text-muted" style={{ fontSize: "14px" }}>WO Final Amount ₹</div><div>{workOrderMaster.woFinalAmount}</div></Col>
                                        <Col md={4}><div className="text-muted" style={{ fontSize: "14px" }}>Type</div><div>{workOrderMaster.woType}</div></Col>
                                        <Col md={4}><div className="text-muted" style={{ fontSize: "14px" }}>Type</div><div>{workOrderMaster.woType}</div></Col>
                                        <Col md={4}><div className="text-muted" style={{ fontSize: "14px" }}>Type</div><div>{workOrderMaster.woType}</div></Col>
                                        <Col md={4}><div className="text-muted" style={{ fontSize: "14px" }}>Type</div><div>{workOrderMaster.woType}</div></Col>
                                        <Col md={4}><div className="text-muted" style={{ fontSize: "14px" }}>Type</div><div>{workOrderMaster.woType}</div></Col>
                                        <Col md={4}><b>WO No:</b> {workOrderMaster.woSerialNo}</Col>
                                        <Col md={4}><b>Type:</b> {workOrderMaster.woType}</Col>
                                        <Col md={4}><b>Status:</b> {workOrderMaster.woExecutionStatus}</Col>
                                        <Col md={4}><b>Booked By:</b> {workOrderMaster.woBookedBy}</Col>
                                        <Col md={4}><b>Booked At:</b> {workOrderMaster.woBookedAt}</Col>
                                        <Col md={4}><b>Amount:</b> ₹{workOrderMaster.woFinalAmount}</Col> */}
                                      <Row className="mb-3"></Row>
                                      {workOrderMaster.woExecutionStatus === "Pending" &&  workOrderMaster.isWoCancelled === "No" && (

                                                <div className="mb-3">

                                                    <Row className="g-3 align-items-end">
                                                    {/* 📋 Reason */}
                                                    <Col md={3}>
                                                        <div className="label-text">Cancellation Reason</div>
                                                        
                                                        <select
                                                                className="form-control form-control-xs"
                                                                value={cancelData?.reasonUUID || ""}                                                                
                                                                onChange={(e) => {
                                                                  const selectedValue = e.target.value;
                                                                  const selectedLabel = e.target.options[e.target.selectedIndex].text;
                                                                  handleCancellationChange(workOrderMaster.woUUID, "reasonUUID", selectedValue);
                                                                  handleCancellationChange(workOrderMaster.woUUID, "reason", selectedLabel);
                                                                  //handleCancellationChange(workOrderMaster.woUUID, "woUUID", workOrderMaster.woUUID);

                                                                  setCancelData((prev) => ({
                                                                    ...prev,
                                                                    reasonUUID: selectedValue,
                                                                    reason: selectedLabel,
                                                                  }));
                                                                }}                                                              
                                                              >
                                                                <option value="">Select</option>

                                                                {woCancelReasonOptions.map((r) => (
                                                                  <option key={r.value} value={r.value}>
                                                                    {r.label}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                    </Col>

                                                    {/* 📝 Remark */}
                                                    <Col md={3}>
                                                        <div className="label-text">Cancellation Remark  - <small>
                                                        {(cancelData?.remark || "").length}/40
                                                        </small></div>
                                                        <input
                                                        type="text"
                                                        maxLength={40}
                                                        className="form-control form-control-xs"
                                                        value={cancelData?.remark || ""}
                                                        onChange={(e) =>{
                                                            handleCancellationChange(workOrderMaster.woUUID, "remark", e.target.value)
                                                            setCancelData((prev) => ({
                                                                    ...prev,
                                                                    remark: e.target.value,
                                                                   
                                                                  }));
                                                        }}
                                                        // onChange={(e) =>
                                                        //     //handlePostponeChange(exe.exeUUID, "remark", e.target.value)
                                                        //     handleCancellationChange(workOrderMaster.woUUID, "remark", cancelData?.remark || "")   
                                                        //     setCancelData((prev) => ({
                                                        //             ...prev,

                                                        //             remark: e.target.value,                                                                    
                                                        //           }));
                                                        // }
                                                        />
                                                        
                                                    </Col>

                                                    <Col md={6} className="text-end">
                                                        <button
                                                            className={`btn btn-xs ${
                                                                !cancelData?.reasonUUID ||
                                                                !cancelData?.reason ||
                                                                !cancelData?.remark
                                                                ? "btn-secondary"
                                                                : "btn-warning"
                                                            }`}
                                                            onClick={() => handleCancelWorkOrderProcess(workOrderMaster.woUUID)}                                                           
                                                            disabled={!cancelreasonLoaded}
                                                            >
                                                            Cancel WO
                                                            </button>
                                                    </Col>
                                                    </Row>

                                                </div>
												                )
                                      }
                                    </div>
                                  </CardBody>
                                </Card>

                                {/* 🔹 2. CUSTOMER DETAILS */}
                                <Card className="mb-3 shadow-sm">
                                    <CardBody>
                                    <h5 className="mb-3">Customer Details</h5>
                                    {/* <Row>
                                        <Col md={4}><b>Name:</b> {workOrderMaster.customerName}</Col>
                                        <Col md={4}><b>Mobile:</b> {workOrderMaster.customersPrimaryMobileNo}</Col>
                                        <Col md={4}><b>Alt Mobile:</b> {workOrderMaster.customersSecondryMobileNo}</Col>
                                        <Col md={12}><b>Address:</b> {workOrderAddress.woServiceLocation}</Col>
                                    </Row> */}

                                    <Row>
                                        <Col md={3}><div className="label-text">Customer Name</div><div className="value-text" style={{ fontSize: "15px", fontWeight:"500" }}> {workOrderMaster.customerName} </div></Col>
                                        <Col md={3}><div className="label-text">Billing Name</div><div className="value-text"> {workOrderMaster.billingName} </div></Col>
                                        <Col md={3}><div className="label-text">Mobile No</div><div className="value-text"> {workOrderMaster.customersPrimaryMobileNo} </div></Col>
                                        <Col md={3}><div className="label-text">Alternate Mobile No</div><div className="value-text"> {workOrderMaster.customersSecondryMobileNo} </div></Col>
                                      </Row>
                                      <Row className="mb-3"></Row>

                                      <Row>
                                        <Col md={3}><div className="label-text">Complaint Raised</div><div className="value-text" style={{ fontSize: "15px", fontWeight:"500" }}> {workOrderMaster.isWoComplaintRaised} </div></Col>
                                        <Col md={7}><div className="label-text">Detail Address</div><div className="value-text"> {workOrderAddress.woDetailAddress} </div></Col>                                        
                                        <Col md={2} className="text-end">
                                            <button
                                            className="btn btn-outline-primary btn-sm mt-4"
                                            onClick={() =>
                                                handleCopyDetailAddress(workOrderAddress.woDetailAddress)
                                            }
                                            >
                                            Copy
                                            </button>
                                        </Col>      
                                      </Row>
                                      <Row className="mb-3"></Row>

                                      <Row>
                                        <Col md={3}><div className="label-text">Complaint Count</div><div className="value-text" style={{ fontSize: "15px", fontWeight:"500" }}> {workOrderMaster.woComplaintCount} </div></Col>
                                        <Col md={7}><div className="label-text">Service Location</div><div className="value-text"> {workOrderAddress.woServiceLocation} </div></Col>
                                        <Col md={2} className="text-end">
                                            <button
                                            className="btn btn-outline-primary btn-sm mt-4"
                                            onClick={() =>
                                                handleCopyLocationAddress(workOrderAddress.woServiceLocation)
                                            }
                                            >
                                            Copy
                                            </button>
                                        </Col>                                       
                                      </Row>
                                    </CardBody>
                                </Card>

                                {/* 🔹 3. PRODUCT DETAILS */}
                                <Card className="mb-3 shadow-sm">
                                    <CardBody>
                                    <h5 className="mb-3">Product Details</h5>

                                    {workOrderDetails.map((product, index) => (
                                        <div key={index} className="border rounded p-2 mb-2">
                                            <Row>
                                                <Col md={6}><div className="label-text">Product Name</div><div className="value-text" style={{ fontSize: "15px", fontWeight:"500" }}> {product.productName} </div></Col>
                                                <Col md={3}><div className="label-text">Product Category</div><div className="value-text"> {product.productSubCategoryName} </div></Col>
                                                <Col md={3}><div className="label-text">Product Sr. No.</div><div className="value-text"> {index + 1} </div></Col>  
                                            </Row>
                                            <Row className="mb-3"></Row>

                                            <Row>
                                                <Col md={3}><div className="label-text">Negoitiated Price ₹</div><div className="value-text" style={{ fontSize: "15px" }}> {product.negotiatedPrice} </div></Col>
                                                <Col md={3}><div className="label-text">MRP ₹</div><div className="value-text"> {product.mrp} </div></Col>
                                                <Col md={3}><div className="label-text">Product Sub Category</div><div className="value-text"> {product.productCategoryName} </div></Col>
                                                <Col md={3}><div className="label-text">Quantity</div><div className="value-text"> {product.qty} </div></Col>                                                
                                            </Row>
                                            <Row className="mb-3"></Row>

                                             <Row>
                                                <Col md={3}><div className="label-text">Validity</div><div className="value-text"> {product.validity} </div></Col>
                                                <Col md={3}><div className="label-text">Guarantee</div><div className="value-text" style={{ fontSize: "15px" }}> {product.guarantee} </div></Col>                                                
                                                <Col md={3}><div className="label-text">Gurantee Finish Date</div><div className="value-text"> {product.guaranteeFinishDate} </div></Col>
                                                <Col md={3}><div className="label-text">Is Gurantee Over</div><div className="value-text"> {product.isGuaranteeOver} </div></Col>                                                                                                
                                            </Row>
                                            <Row className="mb-3"></Row>

                                             <Row>
                                                <Col md={3}><div className="label-text">Product Executions</div><div className="value-text"> {product.productExecutions} </div></Col>
                                                <Col md={3}><div className="label-text">Execution Completed</div><div className="value-text" style={{ fontSize: "15px" }}> {product.noOfExeCompleted} </div></Col>                                                
                                                <Col md={3}><div className="label-text">Execution Pending</div><div className="value-text" style={{ fontSize: "15px" }}> {product.noOfExePending} </div></Col>
                                                <Col md={3}><div className="label-text">Execution Interval</div><div className="value-text"> {product.executionInterval} </div></Col>                                                                                                
                                            </Row>                                            
                                        </div>
                                    ))}

                                    </CardBody>
                                </Card>

                                {/* 🔹 4. EXECUTION SECTION */}
                                    <Card className="mb-3 shadow-sm">
                                    <CardBody>
                                        <h5 className="mb-3">Execution Details</h5>

                                        {processedExecutions.map((exe, index) => {

                                        const canPostpone =
                                            exe?.isExecutionCompleted === "Pending" &&
                                            exe?.isExecutionCancelled === "No";

                                            return (
                                            
                                        <div
                                            key={exe.exeUUID}
                                            className={`border rounded p-3 mb-3 ${
                                            exe.isExecutionCompleted === "Yes" ? "border-success" : "border-warning"
                                            }`}
                                            
                                        >
                                                <Row>
                                                    <Col md={3}><div className="label-text">Execution No. </div><div className="value-text" style={{ fontSize: "15px", fontWeight:"500" }}> {exe.executionNo} </div></Col>
                                                    <Col md={3}><div className="label-text">Execution Serial</div><div className="value-text"> {exe.exeSerialNo} </div></Col>
                                                    <Col md={3}><div className="label-text">WO Serial</div><div className="value-text"> {workOrderMaster.woSerialNo} </div></Col>  
                                                    <Col md={3}><div className="label-text">Execution Type</div><div className={`badge ${getBadgeClassForWOType(exe.woType)} px-3 py-2 status-badge`}> {exe.woType.toUpperCase()} </div></Col>  
                                                </Row>
                                                <Row className="mb-3"></Row>

                                                <Row>
                                                    <Col md={3}><div className="label-text">Execution Date</div><div className="value-text" > {exe.executionDate} </div></Col>                                                    
                                                    <Col md={3}><div className="label-text">Execution Amount ₹</div><div className="value-text"> {exe.exeAmount} </div></Col>  
                                                    <Col md={3}><div className="label-text">Received Amount ₹</div><div className="value-text"> {exe.exeAmountReceived} </div></Col>
                                                    <Col md={3}><div className="label-text">Payment Mode</div><div className="value-text"> {exe.paymentMode} </div></Col>   
                                                </Row>
                                                <Row className="mb-3"></Row>

                                                <Row>
                                                    <Col md={3}><div className="label-text">Execution Time</div><div className="value-text"> {exe.executionTime} </div></Col>  
                                                    <Col md={3}><div className="label-text">Working Time Require</div><div className="value-text"> {exe.executionTimeRequire} </div></Col>
                                                    <Col md={3}><div className="label-text"></div><div className="value-text"> {} </div></Col>  
                                                    <Col md={3}><div className="label-text"></div><div className="value-text"> {} </div></Col>
                                                </Row>
                                                <Row className="mb-3"></Row>

                                                <Row>
                                                    <Col md={6}><div className="label-text">Product Name</div><div className="value-text" > {exe.exeProduct} </div></Col>
                                                    <Col md={3}><div className="label-text">Product Sub Category</div><div className="value-text"> {exe.exeProductSubCategory}</div></Col>
                                                    <Col md={3}><div className="label-text">Product Category</div><div className="value-text"> {exe.exeProductCategory} </div></Col>                                                    
                                                    <Col md={3}><div className="label-text"></div><div className="value-text" >{} </div></Col>
                                                </Row>
                                                <Row className="mb-3"></Row>

                                                <Row>
                                                    <Col md={3}><div className="label-text">Field Executive</div><div className="value-text"> {exe.fieldExecutiveName} </div></Col>
                                                    <Col md={3}><div className="label-text">Operation Executive</div><div className="value-text" > {exe.schedulerName} </div></Col>
                                                    <Col md={3}><div className="label-text">Telecaller</div><div className="value-text"> {exe.telecallerName} </div></Col> 
                                                    <Col md={3}><div className="label-text">Exe. Completed At</div><div className="value-text"> {exe.exeCompletedDatetime} </div></Col>
                                                </Row>
                                                <Row className="mb-3"></Row>

                                                <Row>
                                                    <Col md={3}><div className="label-text">Execution Status</div><div className={`badge ${getBadgeClass(exe.isExecutionCompleted)} px-3 py-2 status-badge`} > {exe.isExecutionCompleted.toUpperCase() === "YES" ? "Completed".toUpperCase() : exe.isExecutionCompleted.toUpperCase()} </div></Col>
                                                    <Col md={3}><div className="label-text">Execution Stage</div><div className="value-text"> {exe.executionStatus} </div></Col>
                                                    <Col md={6}><div className="label-text">Message For Operation Executive</div><div className="value-text " style={{ color:"#F20505" }}> {exe.messageForScheduler } </div></Col>
                                         
                                                </Row>
                                                <Row className="mb-3"></Row>

                                                <Row>
                                                    <Col md={3}><div className="label-text">Execution Cancelled</div><div className={`badge ${getBadgeClassForExecutionCancelled(exe.isExecutionCancelled)} px-3 py-2 status-badge`}> {exe.isExecutionCancelled.toUpperCase()} </div></Col>
                                                    <Col md={3}><div className="label-text">Execution Cancellation At</div><div className="value-text"> {exe.exeCancellationDatetime} </div></Col>
                                                    <Col md={3}><div className="label-text">Execution Cancellation By</div><div className="value-text" > {exe.exeCancellationBy} </div></Col>
                                                    <Col md={3}><div className="label-text"></div><div className="value-text" > {} </div></Col>
                                                </Row> 
                                                <Row className="mb-3"></Row>
                                              
                                              
                                                {exe.isExecutionCompleted === "Pending" &&  exe.isExecutionCancelled === "No" && (

                                                <div className="mb-3">

                                                    <Row className="g-3 align-items-end">

                                                    {/* 📅 Date */}
                                                    <Col md={3}>
                                                        <div className="label-text">Reschedule Date</div>
                                                        <input
                                                        type="date"
                                                        className="form-control form-control-xs"
                                                        value={postponeData[exe.exeUUID]?.date || ""}
                                                        onChange={(e) =>
                                                            handlePostponeChange(exe.exeUUID, "date", e.target.value)
                                                        }
                                                        />
                                                    </Col>

                                                    {/* ⏰ Time */}
                                                    <Col md={3}>
                                                        <div className="label-text">Reschedule Time</div>
                                                        <input
                                                        type="time"
                                                        className="form-control form-control-xs"
                                                        value={postponeData[exe.exeUUID]?.time || "14:30"}

                                                        onChange={(e) =>
                                                          {
                                                            
                                                            //const formattedTime = new Date(`1970-01-01T${time}`).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                                                            const formattedTime = postponeData[exe.exeUUID]?.time
                                                                  ? new Date(`1970-01-01T${postponeData[exe.exeUUID].time}`)
                                                                      .toLocaleTimeString("en-GB", {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                      })
                                                                  : "";
                                                                  //alert('1 ' + formattedTime + ' - ' + e.target.value);
                                                            handlePostponeChange(exe.exeUUID, "time", e.target.value)
                                                            //alert('2 ' + formattedTime + ' - ' + e.target.value);
                                                          }
                                                        }
                                                        />
                                                    </Col>

                                                    {/* 📋 Reason */}
                                                    <Col md={3}>
                                                        <div className="label-text">Reschedule Reason</div>
                                                        {/* <select
                                                        className="form-control form-control-sm"
                                                        value={postponeData[exe.exeUUID]?.reason || ""}
                                                        onChange={(e) =>
                                                            handlePostponeChange(exe.exeUUID, "reason", e.target.value)
                                                        }
                                                        >
                                                        <option value="">Select</option>
                                                        <option value="Customer Request">Customer Request</option>
                                                        <option value="Staff Not Available">Staff Not Available</option>
                                                        <option value="Reschedule">Reschedule</option>
                                                        </select> */}
                                                        <select
                                                                className="form-control form-control-xs"
                                                                value={postponeData[exe.exeUUID]?.reasonUUID || ""}

                                                                onChange={(e) => {
                                                                  const selectedValue = e.target.value;
                                                                  const selectedLabel = e.target.options[e.target.selectedIndex].text;

                                                                  handlePostponeChange(exe.exeUUID, "reasonUUID", selectedValue);
                                                                  handlePostponeChange(exe.exeUUID, "reason", selectedLabel);
                                                                }}                                                                
                                                              >
                                                                <option value="">Select</option>

                                                                {reasonOptions.map((r) => (
                                                                  <option key={r.value} value={r.value}>
                                                                    {r.label}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                    </Col>

                                                    {/* 📝 Remark */}
                                                    <Col md={3}>
                                                        <div className="label-text">Reschedule Remark  - <small>
                                                        {(postponeData[exe.exeUUID]?.remark || "").length}/40
                                                        </small></div>
                                                        <input
                                                        type="text"
                                                        maxLength={40}
                                                        className="form-control form-control-xs"
                                                        value={postponeData[exe.exeUUID]?.remark || ""}
                                                        onChange={(e) =>
                                                            handlePostponeChange(exe.exeUUID, "remark", e.target.value)
                                                        }
                                                        />
                                                        
                                                    </Col>

                                                    </Row>
                                                    <Row className="mb-3"></Row>
                                                   

                                                    {/* 🔘 BUTTON ROW */}
                                                    <Row className="g-3 align-items-end">

                                                    {/* 📝 Scheduler Message */}
                                                    <Col md={6}>
                                                        <div className="label-text">Instruction for Openration Executive - <small>
                                                        {(postponeData[exe.exeUUID]?.schedulerMessage || "").length}/90
                                                        </small></div>
                                                        <input
                                                        type="text"
                                                        maxLength={90}
                                                        className="form-control form-control-xs"
                                                        value={postponeData[exe.exeUUID]?.schedulerMessage || ""}
                                                        onChange={(e) =>
                                                            handlePostponeChange(exe.exeUUID, "schedulerMessage", e.target.value)
                                                        }
                                                        />
                                                        
                                                    </Col>



                                                    <Col md={6} className="text-end">
                                                        <button
                                                            className={`btn btn-xs ${
                                                                !postponeData[exe.exeUUID]?.date ||
                                                                !postponeData[exe.exeUUID]?.time ||
                                                                !postponeData[exe.exeUUID]?.reason
                                                                ? "btn-secondary"
                                                                : "btn-warning"
                                                            }`}
                                                            onClick={() => handleReschedule(exe)}
                                                            // disabled={
                                                            //     !postponeData[exe.exeUUID]?.date ||
                                                            //     !postponeData[exe.exeUUID]?.time ||
                                                            //     !postponeData[exe.exeUUID]?.reason
                                                            // }
                                                            disabled={!reasonLoaded}
                                                            >
                                                            Reschedule
                                                            </button>
                                                    </Col>
                                                    </Row>

                                                </div>
                                                )}                                               
                                        </div>
                                        );
                                        //))}
                                        })}
                                    </CardBody>
                                    </Card>

                    </Container>
              </div>
                    {
                        isPopupVisible && (
                            <PopupWindow
                                message={popupMessage}
                                type={popupType}
                                onClose={closePopup}
                            />
                        )
                    }
                </div >
                );
            };
        }
    }


WorkOrderDetailsV2.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(WorkOrderDetailsV2);


